import { useContext, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import BrixigoPageLoader from "../common/BrixigoPageLoader";
import { AuthContext } from "../../Moduels/Context/AuthContext";
import { storeSocialAuthError } from "../../utils/socialAuthSession";

export default function SocialAuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithToken } = useContext(AuthContext);

  useEffect(() => {
    const token = searchParams.get("token");
    const err = searchParams.get("error");

    if (err) {
      storeSocialAuthError(decodeURIComponent(err));
      navigate("/login", { replace: true });
      return;
    }

    if (!token) {
      storeSocialAuthError("Social sign-in did not return a session. Please try again.");
      navigate("/login", { replace: true });
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        await loginWithToken(token);
        if (!cancelled) navigate("/dashboard", { replace: true });
      } catch {
        if (!cancelled) {
          storeSocialAuthError("Could not complete social sign-in. Please try again.");
          navigate("/login", { replace: true });
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [loginWithToken, navigate, searchParams]);

  return <BrixigoPageLoader overlay message="Completing sign-in…" />;
}
